import React, { useMemo } from 'react';
import { useAppSelector, useTranslate } from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import { Product } from '@src/core/buyerApiClient';
import ProductAdderBody from '@src/domains/products/features/productAdder/components/ProductAdderBody';
import SpinnerBar from '@src/components/reusable/spinner/SpinnerBar';
import { productAdderStepState } from '@src/stores/product';
import { Container, ImageContainer, SelectionArea, SelectionTitle } from './styles';

interface AdderBodyProps {
  selectedProduct: Product | undefined;
  loadingProduct: boolean;
}

const AdderBody = ({ selectedProduct, loadingProduct }: Readonly<AdderBodyProps>) => {
  const { i18n } = useTranslate();
  const widgetId = useWidgetId();
  const { currentStep } = useAppSelector(productAdderStepState(widgetId));

  const isQuantityStep = currentStep === 'package_quantity';

  const stepText = useMemo(() => {
    const stepTexts: Record<string, string> = {
      calendar: i18n('product_package_adder_selection_step_calendar'),
      tariff: i18n('product_package_adder_selection_step_tariff'),
      seat_map: i18n('product_package_adder_selection_step_seat_map'),
      additional: i18n('product_package_adder_selection_step_additional'),
      package_quantity: i18n('product_package_single_booking_quantity_step_title'),
    };

    return currentStep ? stepTexts[currentStep] ?? '' : '';
  }, [currentStep, i18n]);

  if (loadingProduct) {
    return (
      <Container>
        <SpinnerBar />
        <p>{i18n('base_loading')}</p>
      </Container>
    );
  }

  return (
    <SelectionArea>
      <SelectionTitle>
        {!isQuantityStep && selectedProduct?.thumbnailUrl ? (
          <ImageContainer>
            <img src={selectedProduct.thumbnailUrl} alt='product thumbnail' />
          </ImageContainer>
        ) : null}
        {stepText}
        {isQuantityStep ? null : selectedProduct?.name ?? ''}
      </SelectionTitle>

      <ProductAdderBody isMultiProductFlow />
    </SelectionArea>
  );
};

export default AdderBody;
